import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

function useModelActions(model) {
  var dispatch = useDispatch();
  return useMemo(function () {
    var _context;

    return _reduceInstanceProperty(_context = _Object$keys((model === null || model === void 0 ? void 0 : model.actionCreators) || {})).call(_context, function (all, key) {
      all[key] = function () {
        var _model$actionCreators;

        return dispatch((_model$actionCreators = model.actionCreators)[key].apply(_model$actionCreators, arguments));
      };

      return all;
    }, {});
  }, [model, dispatch]);
}

export default useModelActions;